import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

const FinishCompositeScreen = ({ navigation }) => {
  return (
    <View>
      <Text>Finish composite screen</Text>
    </View>
  );
};

const styles = StyleSheet.create({});

export default FinishCompositeScreen;
